export default "__VITE_ASSET__BPWXEekU__"